import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { 
  addToCart, 
  // addPromoKaos, 
  removeCartItem 
} from "features/common/layouts/cartSlice";
import { useLocation } from "react-router-dom";
import { useQuery, formatIDR } from "helpers/utils";
import { notifyWarning } from "components/ToastMessage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

const PromoKaosTumbler = ({ price, billingcycle }) => {
  const dispatch = useDispatch();
  // const isEligibleForPromo = price >= 3000000;
  // const [promoKaosTumbler, setPromoKaosTumbler] = useState(false);
  const [maintenancePrice, setMaintenancePrice] = useState(0);
  const [oriMaintenancePrice, setOriMaintenancePrice] = useState(0);
  const [sslPremiumPrice, setSslPremiumPrice] = useState(0);
  const [oriSslPremiumPrice, setOriSslPremiumPrice] = useState(0);
  const [emailTitanProPrice, setEmailTitanProPrice] = useState(0);
  const [oriEmailTitanProPrice, setOriEmailTitanProPrice] = useState(0);
  const [monitimePrice, setMonitimePrice] = useState(0);
  const [oriMonitimePrice, setOriMonitimePrice] = useState(0);
  const [products, setProducts] = useState([]);
  const [emailAccountValue, setEmailAccountValue] = useState(0);
  const productsCache = useRef({});
  const isInitialized = useRef(false);
  const query = useQuery();
  const isOrderEmailSuitePage =
    useLocation().pathname === "/orderemailsuite" && query.pid === "924";
  const isJasaMaintenanceWebsite =
    useLocation().pathname === "/orderhosting" && query.pid === "1110";
  const [selectedMaintenanceCycle, setSelectedMaintenanceCycle] = useState(billingcycle);
  const [selectedMonitimeCycle, setSelectedMonitimeCycle] = useState(billingcycle);
  const [isMaintenanceChecked, setIsMaintenanceChecked] = useState(false);
  const [isMonitimeChecked, setIsMonitimeChecked] = useState(false);
  const [isEmailTitanChecked, setIsEmailTitanChecked] = useState(false);
  const [showOtherProducts, setShowOtherProducts] = useState(false);

  useEffect(() => {
    async function fetchProduct(pid, billingcycle) {
      const url = `${process.env.REACT_APP_BASE_API}order/apis/getProducts.php?pid=${pid}`;

      try {
        const response = await fetch(url);
        const data = await response.json();
        const product = data.products.product[0];
        const {
          pid,
          gid,
          name,
          type,
          customfields: { customfield: customfieldvalue },
          configoptions,
          pricing: { IDR: pricingIDR }
        } = product;

        return {
          pid,
          gid,
          customfieldvalue,
          name,
          type,
          configoptions,
          pricing: pricingIDR,
          billingcycle
        };
      } catch (error) {
        console.error("Error fetching product:", error);
        return null;
      }
    }

    async function fetchProducts() {
      // Only fetch if not initialized
      if (!isInitialized.current) {
        const product1110 = await fetchProduct("1110", billingcycle); // Maintenance
        const product1146 = await fetchProduct("1146", billingcycle); // Monitime
        const product110 = await fetchProduct("110", billingcycle);
        const product924 = await fetchProduct("924", billingcycle);
        
        // Array order: [Maintenance, Monitime, SSL, Email]
        // products[0] = Maintenance (PID 1110)
        // products[1] = Monitime (PID 1146) 
        // products[2] = SSL (PID 110)
        // products[3] = Email (PID 924)
        setProducts([product1110, product1146, product110, product924]);
        isInitialized.current = true;
      }
    }

    fetchProducts();
  }, [billingcycle]);

  useEffect(() => {
    const maintenanceProduct = products[0];
    if (maintenanceProduct) {
      const basePrice = parseFloat(maintenanceProduct.pricing[billingcycle]) || 0;
      setMaintenancePrice(basePrice * 1.2);
      setOriMaintenancePrice(basePrice);
    }

    const monitimeProduct = products[1];
    if (monitimeProduct) {
      const basePrice = parseFloat(monitimeProduct.pricing[billingcycle]) || 0;
      // Harga original = harga API + 5000
      // Harga promo = harga API (sudah ada diskon 5000)
      setMonitimePrice(basePrice);
      setOriMonitimePrice(basePrice + 5000);
    }

    const sslProduct = products[2];
    if (sslProduct) {
      // SSL hanya tersedia untuk annually
      if (billingcycle === "annually") {
        const originalPrice = parseFloat(sslProduct.pricing.annually) || 0;
        if (originalPrice > 0) {
          const discountSsl = originalPrice - 40000;
          setSslPremiumPrice(Math.max(0, discountSsl)); // Pastikan tidak negatif
          setOriSslPremiumPrice(originalPrice);
        } else {
          setSslPremiumPrice(0);
          setOriSslPremiumPrice(0);
        }
      } else {
        // Untuk billing cycle lain, SSL tidak tersedia
        setSslPremiumPrice(0);
        setOriSslPremiumPrice(0);
      }
    }

    const emailProduct = products[3];
    if (emailProduct && emailProduct.configoptions?.configoption[0]?.options?.option[0]?.pricing?.IDR) {
      const pricingIDR = emailProduct.configoptions.configoption[0].options.option[0].pricing.IDR;
      const validBillingCycles = ["annually", "monthly"];
      const emailBillingCycle = validBillingCycles.includes(billingcycle)
        ? billingcycle
        : "annually";

      // Ambil harga sesuai billing cycle
      const basePrice = parseFloat(pricingIDR[emailBillingCycle]) || 0;
      setEmailTitanProPrice(basePrice); // Harga setelah diskon
      setOriEmailTitanProPrice(basePrice * 1.1); // Harga original + 10%
    } else {
      // Debug logging untuk melihat struktur data
      console.log("Debug - All products:", products);
      console.log("Debug - Email product (products[3]):", emailProduct);
      if (emailProduct) {
        console.log("Debug - Email configoptions:", emailProduct.configoptions);
      }
    }
    // console.log(products);
  }, [products, billingcycle]);

  const changeMaintenanceCheckbox = (e) => {
    const maintenanceProduct = products[0];
    const isChecked = e.target.checked;
    setIsMaintenanceChecked(isChecked);

    if (isChecked && maintenancePrice > 0) {
      dispatch(
        addToCart({
          gid: maintenanceProduct.gid,
          pid: maintenanceProduct.pid,
          name: maintenanceProduct.name,
          type: maintenanceProduct.type,
          billingcycle: selectedMaintenanceCycle,
          price: oriMaintenancePrice,
          customfield: [],
          customfieldvalue: maintenanceProduct.customfieldvalue,
        })
      );
    } else {
      dispatch(removeCartItem(maintenanceProduct.pid));
    }
  };

  const changeMonitimeCheckbox = (e) => {
    const monitimeProduct = products[1];
    const isChecked = e.target.checked;
    setIsMonitimeChecked(isChecked);

    if (isChecked && monitimePrice > 0) {
      dispatch(
        addToCart({
          gid: monitimeProduct.gid,
          pid: monitimeProduct.pid,
          name: monitimeProduct.name,
          type: monitimeProduct.type,
          billingcycle: selectedMonitimeCycle,
          price: monitimePrice,
          customfield: [],
          customfieldvalue: monitimeProduct.customfieldvalue,
        })
      );
    } else {
      dispatch(removeCartItem(monitimeProduct.pid));
    }
  };

  const changeSslPremiumCheckbox = (e) => {
    const sslProduct = products[2];
    if (e.target.checked && sslPremiumPrice > 0) {
      dispatch(
        addToCart({
          gid: sslProduct.gid,
          pid: sslProduct.pid,
          name: sslProduct.name,
          type: sslProduct.type,
          billingcycle: "annually",
          price: sslPremiumPrice,
          customfield: [],
          customfieldvalue: sslProduct.customfieldvalue,
        })
      );
    } else {
      dispatch(removeCartItem(sslProduct.pid));
    }
  };

  const changeEmailTitanProCheckbox = (e) => {
    const isChecked = e.target.checked;
    setIsEmailTitanChecked(isChecked);
    
    const emailProduct = products[3];
    
    // Defensive programming - cek struktur data
    if (!emailProduct || !emailProduct.configoptions || !emailProduct.configoptions.configoption) {
      console.error("Email product structure invalid:", emailProduct);
      notifyWarning("Data produk email tidak valid, silakan refresh halaman");
      return;
    }
    
    const configOption = emailProduct.configoptions.configoption[0];
    if (!configOption || !configOption.options || !configOption.options.option) {
      console.error("Config option structure invalid:", configOption);
      notifyWarning("Konfigurasi produk email tidak valid, silakan refresh halaman");
      return;
    }
    
    if (emailAccountValue === 0) {
      notifyWarning("Maaf, Jumlah akun email tidak boleh kurang dari 1");
      setEmailAccountValue(1);
      dispatch(
        addToCart({
          pid: emailProduct.pid,
          name: emailProduct.name,
          billingcycle: emailProduct.billingcycle,
          duration: emailProduct.billingcycle,
          price: emailTitanProPrice,
          customfield: [],
          customfieldvalue: emailProduct.customfieldvalue,
          configoptions: [
            {
              id: 100,
              value: 1,
            },
          ],
          type: "emailSuite",
        })
      );
      return;
    }

    if (isChecked && emailAccountValue > 0) {
      // Ambil pricing dengan error handling
      const pricingData = configOption.options.option[0].pricing?.IDR;
      if (!pricingData || !pricingData[emailProduct.billingcycle]) {
        console.error("Pricing data not found:", pricingData);
        notifyWarning("Data harga email tidak tersedia");
        return;
      }
      
      const price = parseInt(pricingData[emailProduct.billingcycle]);
      const totalPrice = price * emailAccountValue;

      dispatch(
        addToCart({
          pid: emailProduct.pid,
          name: emailProduct.name,
          billingcycle: emailProduct.billingcycle,
          duration: emailProduct.billingcycle,
          price: totalPrice,
          customfield: [],
          customfieldvalue: emailProduct.customfieldvalue,
          configoptions: [
            {
              id: 100,
              value: emailAccountValue,
            },
          ],
          type: "emailSuite",
        })
      );
    } else {
      dispatch(removeCartItem(emailProduct.pid));
    }
  };

  const changeEmailAccount = (e) => {
    const inputValue = parseInt(e.target.value);
    const newValue = isNaN(inputValue) || inputValue < 1 ? 0 : inputValue;
    setEmailAccountValue(newValue);

    // Jika checkbox tercentang, update cart
    if (isEmailTitanChecked && newValue > 0) {
      const emailProduct = products[3];
      
      // Defensive programming - cek struktur data
      if (!emailProduct || !emailProduct.configoptions || !emailProduct.configoptions.configoption) {
        console.error("Email product structure invalid:", emailProduct);
        notifyWarning("Data produk email tidak valid");
        return;
      }
      
      const configOption = emailProduct.configoptions.configoption[0];
      if (!configOption || !configOption.options || !configOption.options.option) {
        console.error("Config option structure invalid:", configOption);
        notifyWarning("Konfigurasi produk email tidak valid");
        return;
      }
      
      const pricingData = configOption.options.option[0].pricing?.IDR;
      if (!pricingData || !pricingData[emailProduct.billingcycle]) {
        console.error("Pricing data not found:", pricingData);
        notifyWarning("Data harga email tidak tersedia");
        return;
      }
      
      const price = parseInt(pricingData[emailProduct.billingcycle]);
      const totalPrice = price * newValue;

      // Hapus item lama dan tambahkan yang baru
      dispatch(removeCartItem(emailProduct.pid));
      dispatch(
        addToCart({
          pid: emailProduct.pid,
          name: emailProduct.name,
          billingcycle: emailProduct.billingcycle,
          duration: emailProduct.billingcycle,
          price: totalPrice,
          customfield: [],
          customfieldvalue: emailProduct.customfieldvalue,
          configoptions: [
            {
              id: 100,
              value: newValue,
            },
          ],
          type: "emailSuite",
        })
      );
    }
  };

  // const changePromoKaosTumbler = (e) => {
  //   const isChecked = e.target.checked;
  //   setPromoKaosTumbler(isChecked);
  //   dispatch(addPromoKaos({ promoKaos: isChecked }));
  // };

  useEffect(() => {
    const removeAllAdditionalProducts = () => {
      if (!products || products.length === 0) return; // Pastikan products tidak null atau kosong
  
      const productIds = products
        .filter(product => product && product.pid) // Filter hanya produk yang valid
        .map(product => product.pid);
      
      productIds.forEach(pid => dispatch(removeCartItem(pid)));
  
      // Reset semua state checkbox
      setIsMaintenanceChecked(false);
      setIsMonitimeChecked(false);
      setIsEmailTitanChecked(false);
      setEmailAccountValue(0);
    };
  
    removeAllAdditionalProducts();
  }, [billingcycle, dispatch, products]);
  
  const changeMaintenanceCycle = (e) => {
    const newCycle = e.target.value;
    setSelectedMaintenanceCycle(newCycle);
    
    // Update pricing display menggunakan data yang sudah ada
    const maintenanceProduct = products[0];
    if (maintenanceProduct && maintenanceProduct.pricing[newCycle]) {
      const newPrice = parseFloat(maintenanceProduct.pricing[newCycle]) || 0;
      setMaintenancePrice(newPrice * 1.2);
      setOriMaintenancePrice(newPrice);
    }
    
    // Jika sudah di-check, update cart
    if (isMaintenanceChecked) {
      const maintenanceProduct = products[0];
      const newPrice = parseFloat(maintenanceProduct.pricing[newCycle]) || 0;
      dispatch(removeCartItem(maintenanceProduct.pid));
      
      dispatch(
        addToCart({
          gid: maintenanceProduct.gid,
          pid: maintenanceProduct.pid,
          name: maintenanceProduct.name,
          type: maintenanceProduct.type,
          billingcycle: newCycle,
          price: newPrice,
          customfield: [],
          customfieldvalue: maintenanceProduct.customfieldvalue,
        })
      );
    }
  };

  const changeMonitimeCycle = (e) => {
    const newCycle = e.target.value;
    setSelectedMonitimeCycle(newCycle);
    
    // Update pricing display menggunakan data yang sudah ada
    const monitimeProduct = products[1];
    if (monitimeProduct && monitimeProduct.pricing[newCycle]) {
      const newPrice = parseFloat(monitimeProduct.pricing[newCycle]) || 0;
      setMonitimePrice(newPrice);
      setOriMonitimePrice(newPrice + 5000);
    }
    
    // Jika sudah di-check, update cart
    if (isMonitimeChecked) {
      const monitimeProduct = products[1];
      const newPrice = parseFloat(monitimeProduct.pricing[newCycle]) || 0;
      dispatch(removeCartItem(monitimeProduct.pid));
      
      dispatch(
        addToCart({
          gid: monitimeProduct.gid,
          pid: monitimeProduct.pid,
          name: monitimeProduct.name,
          type: monitimeProduct.type,
          billingcycle: newCycle,
          price: newPrice,
          customfield: [],
          customfieldvalue: monitimeProduct.customfieldvalue,
        })
      );
    }
  };

  return (
    <>
      {/* {price <= 3000000 && price > 0 && (
        <div className="col-12 mt-4 mb-3">
          <span className="text-qw-primary fw-medium">
            Tambahkan produk lainnya untuk mendapatkan kaos dan tumbler gratis!
          </span>
          <br />
          <span className="text-muted fw-medium">
            Kurang: Rp -{(3000000 - price).toLocaleString("id-ID")} Lagi
          </span>
        </div>
      )}
      {isEligibleForPromo && price > 0 && (
        <div className="col-12 mt-4">
          <span className="text-success fw-semibold">
            Selamat! Anda mendapatkan kaos dan tumbler gratis!
          </span>
        </div>
      )} */}

      {/* <div className="row">
        <div className="col-12 col-lg-8 d-flex align-items-center">
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              name="kaos_tumbler"
              id="kaos_tumbler"
              value="kaos_tumbler"
              onChange={changePromoKaosTumbler}
              checked={promoKaosTumbler && isEligibleForPromo}
              disabled={!isEligibleForPromo}
            />
            <label
              htmlFor="kaos_tumbler"
              className="ms-3 form-check-label fw-bold"
              style={{ fontSize: "16px" }}
            >
              Gratis Kaos dan Tumbler (Termasuk Ongkir)
            </label>
          </div>
        </div>
        <div className="col-12 col-lg-4 d-grid justify-content-end align-items-center">
          <p className="fw-bold mb-0 d-inline-block text-secondary">
            <del>Rp150.000</del>
          </p>
          <span className="badge btn-cta p-2">GRATIS!</span>
        </div>
      </div> */}

      {price > 0 && (
        <>
          {/* Offers Product (Optional) Label */}
          <div className="row mt-4 mb-3">
            <div className="col-12 d-flex align-items-center">
              <button
                className="btn btn-link fw-bold text-muted p-0 d-flex align-items-center"
                type="button"
                onClick={() => setShowOtherProducts((prev) => !prev)}
                style={{ fontSize: "1.1rem", textDecoration: "none" }}
              >
                Produk Lainnya
                {showOtherProducts ? (
                  <FontAwesomeIcon icon={faChevronUp} className="ms-2" />
                ) : (
                  <FontAwesomeIcon icon={faChevronDown} className="ms-2" />
                )}
              </button>
            </div>
          </div>
          {/* offer Product */}
          {showOtherProducts && (
            <>
              {!isJasaMaintenanceWebsite && (
                <div className="row">
                  <div className="col-12 col-lg-8">
                    <div className="form-check d-flex align-items-center">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        name="maintenance_service"
                        id="maintenance_service"
                        value="maintenance_service"
                        checked={isMaintenanceChecked}
                        onChange={changeMaintenanceCheckbox}
                        disabled={maintenancePrice === 0 || oriMaintenancePrice === 0}
                      />
                      <label
                        htmlFor="maintenance_service"
                        className="ms-3 form-check-label fw-bold"
                        style={{ fontSize: "16px" }}
                      >
                        Jasa Maintenance Website
                        <img
                          className="iconinformation"
                          loading="lazy"
                          src={`${process.env.REACT_APP_QWORDS_API}wp-content/themes/goldenfast/assets/images/icons/info20px.png`}
                          alt="info"
                          data-bs-toggle="modal"
                          data-bs-target="#maintenanceInfoModal"
                          style={{ cursor: "pointer", marginLeft: "8px" }}
                        />
                      </label>
                      <select
                        className="form-select ms-3"
                        style={{ maxWidth: "200px" }}
                        value={selectedMaintenanceCycle}
                        onChange={changeMaintenanceCycle}
                      >
                        <option value="monthly">1 Bulan</option>
                        <option value="quarterly">3 Bulan</option>
                        <option value="semiannually">6 Bulan</option>
                        <option value="annually">1 Tahun</option>
                        <option value="biennially">2 Tahun</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-12 col-lg-4 d-flex flex-column align-items-end">
                    <p className="fw-bold mb-0 d-inline-block text-secondary">
                      <del>{formatIDR(maintenancePrice)}</del>
                    </p>
                    <div className="d-flex align-items-center">
                      <span className="badge btn-cta p-2 me-2">PROMO!</span>
                      <p className="fw-bold mb-0 d-inline-block text-secondary">
                        {formatIDR(oriMaintenancePrice)}
                      </p>
                    </div>
                  </div>
                </div>
              )}

                             <div className="row mt-3">
                 <div className="col-12 col-lg-8">
                   <div className="form-check d-flex align-items-center">
                     <input
                       type="checkbox"
                       className="form-check-input"
                       name="monitime_service"
                       id="monitime_service"
                       value="monitime_service"
                       checked={isMonitimeChecked}
                       onChange={changeMonitimeCheckbox}
                       disabled={monitimePrice === 0 || oriMonitimePrice === 0}
                     />
                     <label
                       htmlFor="monitime_service"
                       className="ms-3 form-check-label fw-bold"
                       style={{ fontSize: "16px" }}
                     >
                       Monitime Hosting
                     </label>
                     <select
                       className="form-select ms-3"
                       style={{ maxWidth: "200px" }}
                       value={selectedMonitimeCycle}
                       onChange={changeMonitimeCycle}
                     >
                       <option value="monthly">1 Bulan</option>
                       <option value="quarterly">3 Bulan</option>
                       <option value="semiannually">6 Bulan</option>
                       <option value="annually">1 Tahun</option>
                       <option value="biennially">2 Tahun</option>
                     </select>
                   </div>
                 </div>
                 <div className="col-12 col-lg-4 d-flex flex-column align-items-end">
                   <p className="fw-bold mb-0 d-inline-block text-secondary">
                     <del>{formatIDR(oriMonitimePrice)}</del>
                   </p>
                   <div className="d-flex align-items-center">
                     <span className="badge btn-cta p-2 me-2">PROMO!</span>
                     <p className="fw-bold mb-0 d-inline-block text-secondary">
                       {formatIDR(monitimePrice)}
                     </p>
                   </div>
                 </div>
               </div>

              <div className="row mt-3">
                <div className="col-12 col-lg-8 d-flex align-items-center">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="ssl_premium"
                      id="ssl_premium"
                      value="ssl_premium"
                      disabled={billingcycle !== "annually" || sslPremiumPrice <= 0}
                      onChange={changeSslPremiumCheckbox}
                    />
                    <label
                      htmlFor="ssl_premium"
                      className="ms-3 form-check-label fw-bold"
                      style={{ fontSize: "16px" }}
                    >
                      SSL Premium Certum <span className="ms-1">(1 Tahun)</span>
                      {billingcycle !== "annually" && (
                        <span className="text-muted ms-1">(Hanya tersedia untuk paket tahunan)</span>
                      )}
                    </label>
                  </div>
                </div>
                <div className="col-12 col-lg-4 d-flex flex-column align-items-end">
                  {billingcycle === "annually" && sslPremiumPrice > 0 ? (
                    <>
                      <p className="fw-bold mb-0 d-inline-block text-secondary">
                        <del>{formatIDR(oriSslPremiumPrice)}</del>
                      </p>
                      <div className="d-flex align-items-center">
                        <span className="badge btn-cta p-2 me-2">PROMO!</span>
                        <p className="fw-bold mb-0 d-inline-block text-secondary">
                          {formatIDR(sslPremiumPrice)}
                        </p>
                      </div>
                    </>
                  ) : (
                    <p className="fw-bold mb-0 d-inline-block text-muted">
                      Tidak tersedia
                    </p>
                  )}
                </div>
              </div>

              {/* order email suite */}
              {!isOrderEmailSuitePage && (
                <div className="row mt-4">
                  <div className="col-12 col-lg-8">
                    <div className="d-flex align-items-center">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name="email_titan_pro"
                          id="email_titan_pro"
                          value="email_titan_pro"
                          checked={isEmailTitanChecked}
                          onChange={changeEmailTitanProCheckbox}
                          disabled={!["annually", "monthly"].includes(billingcycle)}
                        />
                        <label
                          htmlFor="email_titan_pro"
                          className="ms-3 form-check-label fw-bold"
                          style={{ fontSize: "16px" }}
                        >
                          Email Titan Pro
                        </label>
                      </div>
                      <div className="ms-4 d-flex align-items-center">
                        <label
                          htmlFor="emailAccount"
                          className="form-label mb-0 me-2"
                        >
                          Jumlah Akun
                        </label>
                        <input
                          type="number"
                          min="1"
                          className="form-control"
                          id="emailAccount"
                          style={{ maxWidth: "80px" }}
                          value={emailAccountValue}
                          disabled={!["annually", "monthly"].includes(billingcycle)}
                          onChange={changeEmailAccount}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-lg-4 d-flex flex-column align-items-end">
                    {["annually", "monthly"].includes(billingcycle) ? (
                      <>
                        <p className="fw-bold mb-0 d-inline-block text-secondary">
                          <del>{formatIDR(oriEmailTitanProPrice)}/Akun</del>
                        </p>
                        <div className="d-flex align-items-center">
                          <span className="badge btn-cta p-2 me-2">PROMO!</span>
                          <p className="fw-bold mb-0 d-inline-block text-secondary">
                            {formatIDR(emailTitanProPrice)}/Akun
                          </p>
                        </div>
                      </>
                    ) : (
                      <p className="fw-bold mb-0 d-inline-block text-secondary">
                        {formatIDR(286800)}/Akun
                      </p>
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}

      {/* Modal for Maintenance Information */}
      <div
        className="modal fade"
        id="maintenanceInfoModal"
        tabIndex="-1"
        aria-labelledby="maintenanceInfoModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="maintenanceInfoModalLabel">
                Jasa Maintenance Website
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <ul>
                <li>Website Management</li>
                <li>Wordpress Management</li>
                <li>Article Update</li>
                <li>Uptime Monitoring</li>
                <li>Tweak Performance</li>
                <li>Backup Services</li>
              </ul>
              <p className="text-muted">
                <small>by  5mnt.com</small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PromoKaosTumbler;
